module.exports = __webpack_public_path__ + "img/logo_text.84dcae3e.svg";